<h3>QUANTUM CIFRIS</h3>
<p> Tra le attività della De Cifris troviamo l'iniziativa Quantum Cifris,
	all'interno della quale prende vita il nostro team che lavora su Quantum
	Cryptography.
</p>

<h4>EVENTI</h4>
<p>Gli eventi proposti verranno mostrati in questa sezione.</p>

<!-- <ul>
						<li>
							Seminario online tenuto da Andrea Basso: Saber: a Post-Quantum Lattice-Based Protocol - 24 agosto 2020. 
						</li>
						<li>
							Primo evento tenuto presso la prestigiosa sede della CONSOB: 9 maggio 2019. 					
						</li>
						<li>
							Sessione dell'iniziativa De Componendis Cifris dentro ITASEC18: 8 febbraio 2018. 
						</li>
					</ul> -->

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<!-- <ul>
						<li>
							<b style="color: blue;">8 Aprile 2021</b>
							<ul>
								<li>
									<b>Emmanuela Orsini, </b> -- COSIC, KU Leuven <br>
									<i>"Post-quantum secure oblivious transfer"</i>.<br>
									<a href="../../../assets/attivita/gruppi/PQCifris/OrsiniSlide.pdf">Slide</a>
									<br>
								</li>
							</ul>
						</li>
					</ul> -->

<h4>PROSSIMI SEMINARI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<!-- <ul>
				<li> 
					<b>2 Novembre 2021</b>
					<ul>
						<li>
							<b>Paolo Santini</b> <br>
							<i>" Recent advances in code-based encryption and digital signatures"</i><br>
							<br>
						</li>
					</ul>
				</li>
				<li>
					<b>7 Dicembre 2021</b>
					<ul>
						<li>
							<b>Cecilia Boschini</b> <br>
							<i>"Leakages in the efficient verification of post-quantum digital signatures"</i><br>
							<br>
						</li>
					</ul>
				</li>
			</ul> -->

<h4>SEMINARI PASSATI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>


<h4>VIDEO</h4>
<p>Disponibili a breve!</p>
<!-- <p>I video di crittografia Post-Quantum disponibili sul nostro <a href="https://www.youtube.com/watch?v
						=c16aoAi-7Bo&list=PLu4yxTVzRRMU93T5hf2mKtVINipn5O69F">canale YouTube.</a></p> -->